import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import UiContentCard from "../../components/cards/UiContentCard"
import London from "../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../styles/img/favourites/tokyo.jpg"
import Dubai from "../../../../styles/img/campaigns/dubai-trip.jpg"
import NewYork from "../../../../styles/img/campaigns/new-york-trip.jpg"
import SpinToWin from "../../../../styles/img/campaigns/spin-to-win.jpg"
import Volvo from "../../../../styles/img/campaigns/volvo.png"
import VolvoEx90 from "../../../../styles/img/campaigns/volvo-ex90.jpg" 
import { useNavigate } from "react-router-dom";

import { UiSlider } from "../../components/common/UiSlider";
import { UiNextArrow, UiPrevArrow } from "../../components/common/UiSliderArrows.jsx";



export default function MyCurrentCampaigns(props) {
    let navigate = useNavigate(); 

    const learnMore = () => {
        let path = `../../ui/incentives-league`; 
        navigate(path);
    }
    const UiCampaignSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"

            }]

    };

    return (
        <>
            <div className='sb-campaigns-slider'>
                <UiSlider UiSliderSettings={UiCampaignSlider}>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    countDownStatus="Coming soon"
                                    cardImg={NewYork}
                                    rating="4.41"
                                    reviews="47"
                                    heading="New York, New York"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    countDownStatus="Active"
                                    cardImg={VolvoEx90}
                                    rating="4.41"
                                    reviews="47"
                                    heading="EX90 Campaign"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    countDownStatus="Closed"
                                    cardImg={SpinToWin}
                                    rating="4.41"
                                    reviews="47"
                                    heading="Spin to Win!!!"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Dubai}
                                    rating="4.41"
                                    reviews="47"
                                    heading="Luxury Dubai Trip"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Volvo}
                                    rating="4.41"
                                    reviews="47"
                                    heading="Sell Accessories"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={SpinToWin}
                                    rating="4.41"
                                    reviews="47"
                                    heading="Spin to Win!!!"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={VolvoEx90}
                                    rating="4.41"
                                    reviews="47"
                                    heading="EX90 Campaign"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                </UiSlider>
                <div className='sb-campaigns-slider__fade-out'></div>
            </div>
        </>
    )
}
